import styled from '@emotion/styled';
import React, { FC } from 'react';

import { ControlledTextInput } from '../../components/ControlledTextInput';
import { Item } from '../../components/Item';

export const GridItem = styled(Item)(() => ({
  paddingTop: 0,
  paddingBottom: '10px',
}));
interface RenderTextInputProps {
  name: string;
  labelText: string;
  placeholder: string;
  type?: string;
}

const RenderTextInput: FC<RenderTextInputProps> = ({
  name,
  labelText,
  placeholder,
  type = 'text',
}) => (
  <GridItem>
    <ControlledTextInput
      name={name}
      labelText={labelText}
      id={name}
      placeholder={placeholder}
      variant="outlined"
      autoComplete={name}
      type={type}
      sx={{
        minWidth: '70%',
        '& .MuiInputBase-input': {
          height: 14,
          p: 0,
        },
      }}
    />
  </GridItem>
);

export default RenderTextInput;
